<!--店铺管理-->
<template>
  <div class="app-container">
    <!--查询条件区域-->
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="120px">
          <el-form-item label="店长手机号:">
            <el-input v-model="queryParam.inputPhone" placeholder="输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="店长姓名:">
            <el-input v-model="queryParam.inputStoreBossName" placeholder="输入会员姓名"></el-input>
          </el-form-item>
          <el-form-item label="店铺名:">
            <el-input v-model="queryParam.inputStoreTitle" placeholder=""></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>

    <div class="title-container" shadow="never" style="margin-top: 10px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit" @click="handleRoleShowDlg()">门店配置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-time" @click="handleAddOssShowDlg()">添加存储空间</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-time" @click="handleAddVccCountShowDlg()">添加短信</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline" @click="handleCreateOneStore()">添加店铺</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit" @click="handleUpdateStoreDlg()">修改门店信息</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit" @click="handleUpdateStoreAddrDlg()">修改门店地址</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit" @click="handleUpdateStoreBusTimeDlg()">修改营业时间</el-button>
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-edit" @click="handleUpdateStorePicDlg()">修改图片</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                :data="tableData"
                v-loading="listLoading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                @row-click="rowClick"
                @selection-change="handleSelectionChange">
        <el-table-column prop="title" label="店铺" ></el-table-column>
        <el-table-column prop="province" label="省" ></el-table-column>
        <el-table-column prop="city" label="市区" ></el-table-column>
        <el-table-column prop="area" label="县" ></el-table-column>
        <el-table-column prop="detailAddress" label="详细地址" ></el-table-column>
        <el-table-column prop="tel" label="门店电话" ></el-table-column>
        <el-table-column prop="bussnessTime" label="营业时间"></el-table-column>
        <el-table-column prop="name" label="店长" ></el-table-column>
        <el-table-column prop="phone" label="店长手机号" width="120"></el-table-column>
        <el-table-column label="合作起始时间" width="120" >
          <template slot-scope="scope">{{scope.row.cooperationStartTime | formatDateTime}}</template>
        </el-table-column>
        <el-table-column label="合作结束时间"  width="120">
          <template slot-scope="scope">{{scope.row.cooperationEndTime | formatDateTime}}</template>
        </el-table-column>
        <el-table-column prop="remVccCounts" label="剩余短信" width="100" ></el-table-column>
        <el-table-column prop="remOssGb" label="剩余存储空间(GB)"  ></el-table-column>
        <el-table-column prop="deleteStatu" label="删除状态" ></el-table-column>
        <el-table-column prop="anotherName" label="亲子别名" ></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleCooperationOneStore(scope.row)"  type="success" plain size="medium">入驻</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>

    <!--    设置合作日期弹窗-->
    <el-dialog
      title="设置合作日期"
      :visible.sync="cooperationDigVisible"
      width="50%"
      center>
      <div class="edit-area">
        <el-form label-width="150px">
          <el-form-item label="店铺名:">
            <el-input v-model="editStoreInfo.title" placeholder="输入店铺名" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="入驻时间:">
            <el-date-picker
              v-model="editCooperationParam.cooperationStartTime"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="timestamp" style="width: 300px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="入驻到期时间:">
            <el-date-picker
              v-model="editCooperationParam.cooperationEndTime"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="timestamp" style="width: 300px;">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cooperationDigVisible = false">取消</el-button>
        <el-button type="primary" @click="handelCooperation()">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="删除店铺"
      :visible.sync="deleteStoreDigVisible"
      width="50%"
      center>
      <div class="edit-area">
        <el-form label-width="150px">
          <el-form-item label="确定要删除店铺:">
            <el-input v-model="deleteStoreInfo.title" placeholder="输入店铺名" style="width: 300px;" :readonly="true"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteStoreDigVisible = false">取消</el-button>
        <el-button type="primary" @click="handleDelOne()">确定删除</el-button>
      </span>
    </el-dialog>
    <!--    添加店铺弹窗-->
    <el-dialog
      title="添加店铺"
      :visible.sync="createStoreDigVisible"
      width="50%"
      top="30px"
      center>
      <div class="edit-area">
        <el-form  ref="baseRef" :model="createStoreInfo" :rules="rules" label-width="150px">
          <el-form-item  label="店铺名:" prop="title" >
            <el-input  v-model="createStoreInfo.title" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item  label="搜索账号:"  >
            <el-input v-model="createStoreInfo.personInChargeAccount" placeholder="输入账号" style="width: 300px"></el-input>
            <el-button  type="primary" size="mini" @click="handleSearchAdmin()" icon="el-icon-search">搜索</el-button>
          </el-form-item>
          <el-form-item  label="店铺负责人:" prop="personInChargeName" >
            <el-input v-model="createStoreInfo.personInChargeName" :readonly="true" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item  label="门店类型:" prop="type" >
            <el-select v-model="createStoreInfo.typeId" placeholder="请选择">
              <el-option
                v-for="item in typeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="短信数量:" prop="vccCounts" >
            <el-input-number v-model="createStoreInfo.vccCounts" style="width: 300px"></el-input-number>
          </el-form-item>
          <el-form-item  label="门店电话:" prop="tel" >
            <el-input v-model="createStoreInfo.tel" placeholder="输入电话" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item  label="地址:"  >
            <el-button  @click="qqMapDlg = true" icon="el-icon-location-outline">定位</el-button>
          </el-form-item>
          <el-form-item  label="当前位置:"  prop="province">
            <el-input v-model="addressComponent.address" :readonly="true" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item  label="街道/镇:"  prop="town">
            <el-select v-model="addressComponent.town" clearable placeholder="请选择">
              <el-option
                v-for="item in townList"
                :key="item.fullname"
                :label="item.fullname"
                :value="item.fullname">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="道路:"  prop="street">
            <el-input v-model="addressComponent.street" :readonly="true" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item  label="地址详情:"  prop="detailAddress" >
            <el-input style="width: 450px"
              type="textarea"
              placeholder="请输入内容"
              v-model="createStoreInfo.detailAddress"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item  label="营业时间:" prop="tel" >
            <el-time-picker style="width: 200px"
                            v-model="createStoreInfo.bussnessTimeStart"
                            format="HH:mm"
                            value-format="HH:mm"
                            :picker-options="{selectableRange: '00:00:00- 23:59:59'}"
                            placeholder="起始"/>
            <el-time-picker style="width: 200px"
                            v-model="createStoreInfo.bussnessTimeEnd"
                            format="HH:mm"
                            value-format="HH:mm"
                            :picker-options="{selectableRange: '00:00:00- 23:59:59'}"
                            placeholder="起始"/>
          </el-form-item>
          <el-form-item  label="店铺描述:" prop="descripe" >
            <el-input style="width: 450px"
                      type="textarea"
                      placeholder="请输入内容"
                      v-model="createStoreInfo.descripe"
                      maxlength="100"
                      show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item  label="上传门店图片:">
            <upload-img  ref="uploadImg" style="width: 300px"></upload-img>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createStoreDigVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAddNewStore()">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="删除图片"
      :visible.sync="visibleDlg"
      width="50%"
      center>

      <div class="edit-area">
        <el-row style="margin-top: 10px">
          <el-col :span="10" ><div style="margin-top: 10px;margin-left: 30px">确定要删除 :</div></el-col>
        </el-row>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlg = false">取消</el-button>
        <el-button type="primary" @click="handleRemoveStorePic()">确定删除</el-button>
      </span>
    </el-dialog>
    <!--    门店功能配置-->
    <el-dialog
      title="门店配置"
      :visible.sync="addRoleDigVisible"
      width="50%"
      center>
      <div class="edit-area">
        <el-form  ref="baseRef"  label-width="150px">
          <el-form-item  label="店铺:" prop="title" >
            <el-input :readonly="true"  style="width: 300px" v-model="selectRow.title"></el-input>
          </el-form-item>
          <el-form-item  label="后端小程序权限:" prop="backMiniFlag" >
            <el-radio-group v-model="selectRow.backMiniFlag">
              <el-radio :label="true">打开</el-radio>
              <el-radio :label="false">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item  label="是否是免费版本:" prop="freeFlag" >
            <el-radio-group v-model="selectRow.freeFlag">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item  label="是否是团购门店:" prop="groupFlag" >
            <el-radio-group v-model="selectRow.groupFlag">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item  label="是否在前端展示:" prop="groupFlag" >
            <el-radio-group v-model="selectRow.frontShowFlag">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item  label="亲子游别名:" prop="title" >
            <el-input style="width: 300px" v-model="selectRow.anotherName"></el-input>
          </el-form-item>
          <el-form-item  label="在线客服坐席号:" prop="title" >
            <el-input style="width: 300px" v-model="selectRow.onlineAgent"></el-input>
          </el-form-item>
          <el-form-item  label="在线客服坐席密码:" prop="title" >
            <el-input style="width: 300px" v-model="selectRow.onlinePassword"></el-input>
          </el-form-item>
          <el-form-item  label="在线客服技能渠道号:" prop="title" >
            <el-input style="width: 300px" v-model="selectRow.onlinePeerId"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addRoleDigVisible = false">取消</el-button>
        <el-button type="primary" @click="handleRole()">确认</el-button>
      </span>
    </el-dialog>
    <!--    添加短信-->
    <el-dialog
      title="添加短信"
      :visible.sync="addVccCountsDigVisible"
      width="50%"
      center>
      <div class="edit-area">
        <el-form  ref="baseRef"  label-width="150px">
          <el-form-item  label="店铺:" prop="title" >
            <el-input :readonly="true"  style="width: 300px" v-model="selectRow.title"></el-input>
          </el-form-item>
          <el-form-item  label="当前剩余短信:" prop="vccCounts" >
            <el-input style="width: 300px" :readonly="true" v-model="selectRow.remVccCounts"></el-input>
          </el-form-item>
          <el-form-item label="添加短信数量:" prop="vccCounts" >
            <el-input-number v-model="addVccCount"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVccCountsDigVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAddVccCount()">确认</el-button>
      </span>
    </el-dialog>
     <!--    添加存储空间-->
     <el-dialog
      title="添加存储空间"
      :visible.sync="addOssDigVisible"
      width="50%"
      center>
      <div class="edit-area">
        <el-form  ref="baseRef"  label-width="150px">
          <el-form-item  label="店铺:" prop="title" >
            <el-input :readonly="true"  style="width: 300px" v-model="selectRow.title"></el-input>
          </el-form-item>
          <el-form-item  label="剩余存储空间(GB):" prop="remOssMb" >
            <el-input style="width: 300px" :readonly="true" v-model="selectRow.remOssGb"></el-input>
          </el-form-item>
          <el-form-item label="添加存储空间(GB):" prop="addOss" >
            <el-input-number v-model="addOss" step="1"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addOssDigVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAddOss()">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="腾讯地图"
      :visible.sync="qqMapDlg"
      width="50%"
      center>
      <qq-map-component  @qqMapAddress="qqMapAddress"></qq-map-component>
    </el-dialog>
    <!--    修改门店信息-->
    <el-dialog
      title="修改门店信息"
      :visible.sync="editStoreDigVisible"
      width="50%"
      center>
      <store-front-detail :store-front="selectRow" @handleSure="handleSure"></store-front-detail>
    </el-dialog>
    <!--    修改门店地址-->
    <el-dialog
      title="修改门店地址"
      :visible.sync="updateStoreAddrDigVisible"
      width="50%"
      center>
      <div class="edit-area">
        <el-form ref="baseRef" :model="createStoreInfo" :rules="rules" label-width="150px">
          <el-form-item  label="店铺名:" prop="title" >
            <el-input :readonly="true" style="width: 300px" v-model="this.selectRow.title"></el-input>
          </el-form-item>
          <el-form-item  label="地址:"  >
            <el-button  @click="qqMapDlg = true" icon="el-icon-location-outline">定位</el-button>
          </el-form-item>
          <el-form-item  label="位置:" prop="province"  >
            <el-input v-model="addressComponent.address" :readonly="true" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item  label="街道/镇:"  prop="town">
            <el-select v-model="addressComponent.town" clearable placeholder="请选择">
              <el-option
                v-for="item in townList"
                :key="item.fullname"
                :label="item.fullname"
                :value="item.fullname">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="道路:"  prop="street">
            <el-input v-model="addressComponent.street" :readonly="true" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item  label="地址详情:"  prop="detailAddress" >
            <el-input style="width: 450px"
                      type="textarea"
                      placeholder="请输入内容"
                      v-model="addressComponent.detailAddress"
                      maxlength="100"
                      show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateStoreAddrDigVisible = false">取消</el-button>
        <el-button type="primary" @click="handleUpdateStoreAddr()">确认</el-button>
      </span>
    </el-dialog>
    <!--    修改门店营业时间-->
    <el-dialog
      title="修改门店营业时间"
      :visible.sync="updateStoreBusTimeDigVisible"
      width="50%"
      center>
      <div class="edit-area">
        <el-form  ref="baseRef"  label-width="150px">
          <el-form-item  label="店铺名:" prop="title" >
            <el-input  readonly="true" style="width: 300px" v-model="this.selectRow.title"></el-input>
          </el-form-item>
          <el-form-item  label="营业时间:"  >
            <el-time-picker style="width: 200px"
                            v-model="editStoreInfo.bussnessTimeStart"
                            format="HH:mm"
                            value-format="HH:mm"
                            :picker-options="{selectableRange: '00:00:00- 23:59:59'}"
                            placeholder="起始"/>
            <el-time-picker style="width: 200px"
                            v-model="editStoreInfo.bussnessTimeEnd"
                            format="HH:mm"
                            value-format="HH:mm"
                            :picker-options="{selectableRange: '00:00:00- 23:59:59'}"
                            placeholder="起始"/>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateStoreBusTimeDigVisible = false">取消</el-button>
        <el-button type="primary" @click="handleUpdateStoreBusTime()">确认</el-button>
      </span>

    </el-dialog>
    <!--    修改门店图片-->
    <el-dialog
      title="修改门店图片"
      :visible.sync="updateStorePicDigVisible"
      width="50%"
      center>
      <div class="edit-area">
        <el-form  ref="baseRef"   label-width="150px">
          <el-form-item  label="店铺名:" prop="title" >
            <el-input  readonly="true" style="width: 300px" v-model="this.selectRow.title"></el-input>
          </el-form-item>
          <el-form-item  label="门店图片:">
            <upload-img :pic-list="selectRow.picUrls"  ref="uploadImgUpdate" :key="uploadImgUpdateKey" style="width: 300px"></upload-img>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateStorePicDigVisible = false">取消</el-button>
        <el-button type="primary" @click="handleUpdateStorePic()">确认</el-button>
      </span>

    </el-dialog>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>

<script>
  import commonUtils from "../../../utils/commonUtils";
  import {formatDate} from '@/utils/date';
  import {
    addNewStore,
    addStoreVccCounts,
    addOssSpace,
    delStore,
    fechListStore,
    storeCooperation,
    updateStoreFront
  } from "../../../api/superAdmin";
  import {getqqAddr} from "../../../api/qqmap";

  import {typeList, } from "../../../api/storeFrontType";
  import {getAdmin, getAdminByPhone} from "../../../api/storeAdmin";
  import globaldata from "../../../utils/globaldata";
  import messageUtils from "../../../utils/messageUtils";
  import {getAddr} from "../../../api/mapqq";
  import qqMapComponent from "../../../components/map/qqMapComponent";
  import UploadImg from "../../components/UploadImg";
  import StoreFrontDetail from "../components/StoreFrontDetail";

  let StoreLocation  ="";

  export default {
    components:{StoreFrontDetail, UploadImg, qqMapComponent},
    data() {
      return {
        cooperationDigVisible :false,
        editStoreDigVisible :false, //编辑店铺弹框
        deleteStoreDigVisible :false, //删除店铺弹框
        createStoreDigVisible : false, //添加店铺弹窗
        addVccCountsDigVisible : false, //添加短信

        updateStoreAddrDigVisible : false, //修改门店地址
        updateStoreBusTimeDigVisible : false, //修改门店营业时间

        updateStorePicDigVisible : false, //修改门店图片
        addRoleDigVisible:false,  //门店权限配置
        addOssDigVisible:false,  //存储空间

        rules:{
          title:[{required:true,message:"请输入门店名",trigger:"blur"}],
          personInChargeName:[{required:true,message:"请选择门店负责人账号",trigger:"blur"}],
          vccCounts:[{required:true,message:"短信数量",trigger:"blur"}],
          tel:[{required:true,message:"请输入门店电话",trigger:"blur"}],
          province:[{required:true,message:"选择门店地址",trigger:"blur"}],
          type:[{required:true,message:"门店类型不能为空",trigger:"blur"}],
        },

        longitude: "",
        latitude: "",
        listLoading: true,
        visibleDlg:false,
        qqMapDlg:false,
        queryParam:{
          inputPhone: '',     //输入手机号
          inputStoreBossName: '',  //输入店长名
          inputUserChild:'',  //输入会员孩子名
          inputCardId :''     ,//输入卡号
          inputStoreTitle : '' ,//店铺名
          cooperationDate:'' ,//合作时间

          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },

        multipleSelection: [], //选择的表单
        //表单结果
        tableData: [
        ],

        /**
         * 当前选中的
         */
        selectRow:"",

        addVccCount:0,
        addOss:0,

        //编辑店铺信息
        editStoreInfo :{
          id: null,
          title:"",
          province: '',
          city:'',
          area:'',
          detailAddress:'',
          cooperationStartTime :'',
          cooperationEndTime :'',
          rankingTopping :'1',
          rankingToppingDays :'50'
        },

        editCooperationParam :{
          id: '1',
          title:"",
          cooperationStartTime :"",
          cooperationEndTime :""
        },

        //添加新店铺参数
        createStoreInfo :{
          title:"",
          descripe:'',
          province: '',
          city:'',
          area:'',
          detailAddress:'',
          personInCharge: '',
          personInChargeName :'',
          personInChargeAccount :'',
          vccCounts:0,
          tel:'',//门店电话
          bussnessTimeStart:'',
          picUrls:[],
          bussnessTimeEnd:'',
          location:'',

          inputSearchPhone :'' //选择店铺负责人的号码
        },

        addressComponent:{},

        fileList: [],
        //删除店铺信息
        deleteStoreInfo :{
          id: '1',
          title:"新的安徽第一游泳馆"

        },
        handleRemoveStorePicIndex :-1,
        uploadImgUpdateKey:"",
        townList:[],
        typeOptions:[],
      }
    },

    created(){

      this.flechList();
      this.initTypeLiet()
    },

    mounted() {

    },
    filters: {
      formatDateTime(time) {
        if (time == null || time === '') {
          return 'N/A';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd')
      },
    },
    methods: {
      flechList(){
        this.listLoading = true;
        let param = {
          title: this.queryParam.inputStoreTitle,
          name : this.queryParam.inputStoreBossName,
          phone : this.queryParam.inputPhone,
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize
        }
        fechListStore(param).then(response => {
          this.listLoading = false;
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.queryParam.totalPage = date.total;
          this.refreshData(date.list);

        })
      },

      initTypeLiet(){
        typeList().then(response => {
          this.typeOptions = response.data
        })
      },

      qqMapAddress(data,lat,lng){
        if (!commonUtils.isObjectNull(data)){
          this.addressComponent = {
            city: data.city,
            district: data.district,
            nation:data.nation,
            province: data.province,
            street: data.street,
            street_number: data.street_number,
            lat:lat,
            lng:lng,
          }
          this.qqMapDlg = false;
          this.addressComponent.address = this.addressComponent.province + "," + this.addressComponent.city + "," + this.addressComponent.district
          this.addressComponent.street = this.addressComponent.street
          this.townList = data.townList
        }
      },

      //刷新页面数据
      refreshData(list){
        if (commonUtils.isObjectNull(list)){
          return;
        }
        this.tableData = list;
        for (let i = 0;i< list.length;++i){
          let deleteStatu = "未删除"
          if(list[i].deleteStatu == 0){
            deleteStatu = "未删除";
          }else {
            deleteStatu= "已删除";
          }
          list[i].deleteStatu = deleteStatu
        }


      },
      handleRemove(file, fileList) {
        console.log("handleRemove",file);
        for (let i =0;i< this.createStoreInfo.picUrls.length;++i){
          if (file.response.data ==  this.createStoreInfo.picUrls[i]){
            this.createStoreInfo.picUrls.splice(i,1);
          }
        }
      },
      handleSuccess(response, file, fileList){
        this.createStoreInfo.picUrls.push(response.data)
      },
      handlePreview(file) {

      },
      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },
      handleSelectionChange(val) {

        this.multipleSelection = val;
      },
      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
      },
      //查看某个店铺
      handleCheckOneStore(row) {

      },
      //合作设置
      handleCooperationOneStore(row){
        this.editCooperationParam  = {
          id:row.id,
          title:row.title,
          cooperationStartTime:  row.cooperationStartTime,
          cooperationEndTime:row.cooperationEndTime,
        },
        this.cooperationDigVisible = true;
      },
      handelCooperation(){

        let param = {
          id:this.editCooperationParam .id,
          cooperationStartTime:this.editCooperationParam.cooperationStartTime,
          cooperationEndTime:this.editCooperationParam.cooperationEndTime,
        }

        storeCooperation(param).then(response =>
        {
          messageUtils.successMsg(this,"设置成功");
          this.cooperationDigVisible = false;
          this.flechList();
        })
      },
      //删除某个店铺
      showDlghandleDeleteOne(row){
        this.deleteStoreDigVisible = true;
        this.deleteStoreInfo = {
          id:row.id,
          title:row.title
        }
      },
      handleDelOne(){
        let param = {
          id :this.deleteStoreInfo.id,
          adminId:globaldata.getAdminStore().id
        }
        delStore(param).then(response => {
          messageUtils.successMsg(this,"删除成功");
          this.deleteStoreDigVisible = false;
          this.flechList();
        })
      },
      //添加某个店铺
      handleCreateOneStore(){
        this.createStoreDigVisible = true;
      },
      //店铺添加图片
      onAddStorePic(){
        this.createStoreInfo.picUrls.push(this.src)
      },

      onRemoveStorePic(index){
        this.handleRemoveStorePicIndex = index;
        this.visibleDlg = true;
      },
      handleRemoveStorePic(){
        let reIndex = this.handleRemoveStorePicIndex;
        if (reIndex >=0){
          var pics =  this.createStoreInfo.picUrls;
          pics = pics.splice(reIndex,1);
        }else {
          this.$message(`选错图片`);
        }
        this.visibleDlg = false;

      },

      //选择店铺的图片
      handleSelectStore(){
        this.visibleDlg = true;
      },
      handleSearchAdmin(){
        let param = {
          account : this.createStoreInfo.personInChargeAccount,
        }
        getAdmin(param).then(response => {
          console.log(response)
          let date = response.data;
          if (!commonUtils.isObjectNull(date)){
            this.createStoreInfo.personInCharge =date.id;
            this.createStoreInfo.personInChargeName =date.name;
          }else {
            this.createStoreInfo.personInCharge =null;
            this.createStoreInfo.personInChargeName = "";
          }

        })

      },

      handleAddNewStore(){
        let pic = this.$refs['uploadImg'].onGetPicUrls();
        pic = JSON.stringify(pic);

        let param = {
          inputAdminId:globaldata.getAdminStore().id,
          province:this.addressComponent.province,
          city:this.addressComponent.city,
          area:this.addressComponent.district,
          latitude:this.addressComponent.lat,
          longitude:this.addressComponent.lng,
          detailAddress:this.createStoreInfo.detailAddress,
          personInCharge:this.createStoreInfo.personInCharge,
          descripe:this.createStoreInfo.descripe,
          vccCounts:this.createStoreInfo.vccCounts,
          picUrls:pic,
          title:this.createStoreInfo.title,
          tel:this.createStoreInfo.tel,
          bussnessTime:  this.createStoreInfo.bussnessTimeStart+ "_" +this.createStoreInfo.bussnessTimeEnd,
          street:this.addressComponent.street,
          town:this.addressComponent.town,
          typeId:this.createStoreInfo.typeId,
        }
        addNewStore(param).then(response => {
          let date = response.data;
          if (!commonUtils.isObjectNull(date)){
            this.createStoreInfo.personInCharge =date.id;
            this.createStoreInfo.personInChargeName =date.name;
          }else {
            this.createStoreInfo.personInCharge =null;
            this.createStoreInfo.personInChargeName = "";
          }
          this.createStoreDigVisible = false;
          this.addressComponent = {}
          this.flechList();

        })

      },
      handleRoleShowDlg(){
        if (commonUtils.isStringNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一家门店")
          return;
        }
        this.addRoleDigVisible = true;
      },
      handleAddVccCountShowDlg(){
        if (commonUtils.isStringNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一家门店")
          return;
        }
        this.addVccCountsDigVisible = true;
      },
      handleAddOssShowDlg(){
        if (commonUtils.isStringNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一家门店")
          return;
        }
        this.addOssDigVisible = true;
      },
      handleAddVccCount(){
        let param = {
          id:this.selectRow.id,
          vccCounts:this.addVccCount
        }
        addStoreVccCounts(param).then(response =>
        {
          let data = response.data;
          if (!commonUtils.isObjectNull(data) && data == true){
            messageUtils.successMsg(this,response.message);
          }else {
            messageUtils.errorMsg(this,response.message);
          }
          this.addVccCountsDigVisible = false;
          this.flechList();
        })
      },
      handleAddOss(){
        let param = {
          id:this.selectRow.id,
          space:this.addOss
        }
        addOssSpace(param).then(response =>
        {
          let data = response.data;
          if (!commonUtils.isObjectNull(data) && data == true){
            messageUtils.successMsg(this,response.message);
          }else {
            messageUtils.errorMsg(this,response.message);
          }
          this.addOssDigVisible = false;
          this.flechList();
        })
      },
      rowClick(row, column, event){
        this.selectRow = row;
      },

      /**
       * 修改门店信息
       */
      handleUpdateStoreDlg(){
        if (commonUtils.isStringNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一家门店")
          return;
        }
        this.editStoreDigVisible = true;
      },

      handleSure(data){
        let param = {
          id : data.id,
          title : data.title,
          tel : data.tel,
          descripe : data.descripe,
          typeId:data.typeId,
        }
        updateStoreFront(param).then(response => {
          let data = response.data;
          if (!commonUtils.isObjectNull(data) && data == true){
            messageUtils.successMsg(this,response.message);
          }else {
            messageUtils.errorMsg(this,response.message);
          }
          this.editStoreDigVisible = false;
          this.flechList();
        })
      },
      handleRole(){
        let param = {
          id:this.selectRow.id,
          backMiniFlag:this.selectRow.backMiniFlag,
          freeFlag:this.selectRow.freeFlag,
          groupFlag:this.selectRow.groupFlag,
          frontShowFlag:this.selectRow.frontShowFlag,
          anotherName:this.selectRow.anotherName,
          onlineAgent:this.selectRow.onlineAgent,
          onlinePeerId:this.selectRow.onlinePeerId,
          onlinePassword:this.selectRow.onlinePassword,
        }
        updateStoreFront(param).then(response => {
          let data = response.data;
          if (!commonUtils.isObjectNull(data) && data == true){
            messageUtils.successMsg(this,response.message);
          }else {
            messageUtils.errorMsg(this,response.message);
          }
          this.addRoleDigVisible = false;
          this.flechList();
        })
      },




      /**
       * 修改门店地址
       */
      handleUpdateStoreAddrDlg(){
        if (commonUtils.isStringNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一家门店")
          return;
        }
        console.log(this.selectRow)
        this.addressComponent = {
          city: this.selectRow.city,
          district: this.selectRow.area,
          province: this.selectRow.province,
          street: this.selectRow.street,
          town: this.selectRow.town,
          lat:this.selectRow.latitude,
          lng:this.selectRow.longitude,
          detailAddress:this.selectRow.detailAddress,
        }
        this.addressComponent.address = this.addressComponent.province + " " + this.addressComponent.city + " " + this.addressComponent.district
        this.updateStoreAddrDigVisible = true;
      },

      handleUpdateStoreAddr(){
        let param = {
          id : this.selectRow.id,
          province: this.addressComponent.province,
          city:this.addressComponent.city,
          area:this.addressComponent.district,
          detailAddress:this.addressComponent.detailAddress,
          latitude:this.addressComponent.lat,
          longitude:this.addressComponent.lng,
          street:this.addressComponent.street,
          town:this.addressComponent.town,
        }

        updateStoreFront(param).then(response => {
          let data = response.data;
          if (!commonUtils.isObjectNull(data) && data == true){
            messageUtils.successMsg(this,response.message);
          }else {
            messageUtils.errorMsg(this,response.message);
          }
          this.updateStoreAddrDigVisible = false;
          this.addressComponent = {}
          this.flechList();

        })


      },


      /**
       * 修改营业时间
       */
      handleUpdateStoreBusTimeDlg(){
        if (commonUtils.isStringNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一家门店")
          return;
        }
        this.updateStoreBusTimeDigVisible = true;
      },

      handleUpdateStoreBusTime(){

        let param = {
          id : this.selectRow.id,
          bussnessTime: this.editStoreInfo.bussnessTimeStart +"-" + this.editStoreInfo.bussnessTimeEnd,
        }

        updateStoreFront(param).then(response =>
        {
          let data = response.data;
          if (!commonUtils.isObjectNull(data) && data == true){
            messageUtils.successMsg(this,response.message);
          }else {
            messageUtils.errorMsg(this,response.message);
          }
          this.updateStoreBusTimeDigVisible = false;
          this.flechList();

        })


      },



      /**
       * 修改门店图片
       */
      handleUpdateStorePicDlg(){
        if (commonUtils.isStringNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一家门店")
          return;
        }
        this.uploadImgUpdateKey = new Date().getTime()
        this.updateStorePicDigVisible = true;
      },

      handleUpdateStorePic(){
        let pic = this.$refs['uploadImgUpdate'].onGetPicUrls();
        pic = JSON.stringify(pic);

        let param = {
          id : this.selectRow.id,
          picUrls: pic
        }

        updateStoreFront(param).then(response =>
        {
          let data = response.data;
          if (!commonUtils.isObjectNull(data) && data == true){
            messageUtils.successMsg(this,response.message);
          }else {
            messageUtils.errorMsg(this,response.message);
          }
          this.updateStoreBusTimeDigVisible = false;
          this.flechList();

        })


      },

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/superadmin/store-manager/index.vue